/**
 * 작성자 : 홍선영
 * 날짜 : 2023.12.05
 * 경로 : 설정관리-터널관리 페이지 (현장관리자)
 */

import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useOutletContext } from 'react-router-dom';
import { IUser, pageInfoState, userState } from '../../atoms';
import styled from 'styled-components';

import { ITabObject } from 'customTypes';
import Tab from '../../components/Tab';
import TAreaInfo from './setting9/tAreaInfo';
import { logPost } from '../../services/log';
import InputList from '../../components/InputList';

const Root = styled.div``;

const SMSetting9 = () => {
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const userInfo = useRecoilValue<IUser>(userState);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);
  const { userMenuList } = userInfo;
  const [newTabList, setNewTabList] = useState<ITabObject[]>();
  const JC = { type: 'jc', endPoint: '/tarea/jclist', dtoKey: 'tareaJcReqDto', nameKey: 'tjcName', codeKey: 'tjcCd', responseArrayKey: 'tareaJcList' };
  const ES = { type: 'es', endPoint: '/tarea/eslist', dtoKey: 'tareaEsReqDto', nameKey: 'tesName', codeKey: 'tesCd', responseArrayKey: 'tareaEsList' };

  useEffect(() => {
    const arr: any[] = [];
    userMenuList.map((v: any) => {
      const result = tabInfo?.tabList?.find((el: ITabObject) => el.mtCd === v.mtCd && el.mdCd === v.mdCd && el.mrCd === v.mrCd);
      if (result) {
        arr.push(result);
        setNewTabList(arr);
      }
    });
  }, [tabInfo.tabList]);

  const onClickTab = (mrCd: string) => {
    setCurrentTabMrCd(mrCd);
  };

  const renderPage = () => {
    const activeTab = userMenuList.find((el: ITabObject) => el.mrCd === currentTabMrCd);
    if (activeTab !== undefined) {
      const { mrCd } = activeTab;
      switch (mrCd) {
        case '001':
          return <TAreaInfo />;
        case '002':
          return <InputList prop={JC} />;
        case '003':
          return <InputList prop={ES} />;
      }
    }
    return undefined;
  };

  return (
    <div className='contents'>
      <Tab tabList={newTabList || tabInfo.tabList} currentTabMrCd={currentTabMrCd} setCurrentTabMrCd={setCurrentTabMrCd} onClickTab={onClickTab} size={size} />
      {renderPage()}
    </div>
  );
};

export default SMSetting9;
